<template>
	<div class="user-center-container">
		<div class="user-center-content">
			<div class="form-header">
				<h3 class="form-title">会员权益</h3>
			</div>
			<div class="member-benefit-title">
				<span class="intro">服务介绍说明</span>
				<span class="vip">普通会员（立即注册）</span>
				<span class="svip">高级会员（VIP）</span>
				<span class="ssvip">超级会员（SVIP）</span>
				<span class="remaining">剩余权益</span>
			</div>

			<div class="member-benefit-content">
				<div v-for="(item, index) in memberBenefitList" :key="index" class="benefit-group">
					<div class="benefit-group-title">
						<span>{{ item.name }}</span>
					</div>

					<div class="benefit-group-content">
						<div v-for="(item1, index1) in item.memberBenefitTemplateVos" :key="index1" class="benefit-group-list">
							<span class="intro">
								<b>{{ item1.memberBenefitName }}</b>
								<p>{{ item1.remark }}</p>
							</span>
							<span class="vip">{{ item1.pthyMemberBenefitContent }}</span>
							<span class="svip">{{ item1.vipMemberBenefitContent }}</span>
							<span class="ssvip">{{ item1.svipMemberBenefitContent }}</span>
							<span class="remaining">
								{{
									item1.benefitLastNumberMap &&
										item1.benefitLastNumberMap.hasOwnProperty('DEFAULT') &&
										item1.benefitLastNumberMap.DEFAULT[0].benefitLastNumberStr
								}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { queryMyMemberBenefitRecord } from '@/api/memberBenefit/index'

	// 我的会员权益
	export default {
		name: 'MyMemberBenefits',
		components: {},
		props: {},
		data() {
			return {
				// 会员权益一览表
				memberBenefitList: []
			}
		},
		computed: {},
		watch: {},
		created() {
			this.handleGetMemberBenefitRecord()
		},
		mounted() {},
		methods: {
			// 查询会员权益汇总
			handleGetMemberBenefitRecord() {
				queryMyMemberBenefitRecord().then(response => {
					const { data } = response

					if (data && data.length) {
						// 取出第0项，平台基础会员
						const { memberBenefitTemplateVos } = data[0]

						this.memberBenefitList = memberBenefitTemplateVos
					} else {
						this.memberBenefitList = []
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	@import '~@/styles/userMemberBenefit.scss';
	.user-center-container {
		.form-header {
			margin-bottom: 20px;
		}
	}
</style>
